import { deviceIsPhone, deviceIsTablet, getOsName, getOsVersion } from '../Utils/Platform';
import { v4 as uuid } from 'uuid';
// import Core from '../Core/Core';
import { EventBuilder } from './EventBuilder';

export enum GamePlatform {
    FBINSTANT = 'FACEBOOK',
    LINE = 'LINE',
    LOCAL = 'local',
}

export enum DeviceTypes {
    MOBILE_PHONE = 'mobile phone',
    TABLET = 'tablet',
    PC = 'pc',
}

interface IGameSessionStartParams {
    deviceType: DeviceTypes;
    gameID: string;
    gameVersion: string;
    operatingSystem: string;
    osVersion: number;
    platform: GamePlatform;
    platformUserID: string;
    sessionID: string;
    tzOffset: string;
    timezoneName: string;
    userID: string;
    loadingTime: number;
    locale: string;
}

// new changing params about current state of game (not saved)
interface IGameSessionChangingParams {
    screenHeight: number;
    screenWidth: number;
    levelsPassedThisSession: number;
    levelsAttemptsThisSession: number;
    boostersUsedThisSession: number;
    adsWatchedThisSessionRewarded: number;
    adsWatchedThisSessionInterstitial: number;
    coinsEarnedThisSession: number;
    coinsSpentThisSession: number;
}

export interface IGameSessionParams extends IGameSessionStartParams, IGameSessionChangingParams {
    [key: string]: unknown;
}

export class SessionParamBuilder extends EventBuilder {
    public sessionStart: number;
    private curSessionData: IGameSessionParams;

    constructor() {
        super();

        this.curSessionData = {
            ...this.createGameStartParams(),
            ...this.createDefaultChangingParams(),
        };
        this.sessionStart = Date.now();
    }

    public setParamsFromGame(data: Partial<IGameSessionParams>) {
        const oldSessionData = { ...this.curSessionData };
        this.curSessionData = Object.assign({}, oldSessionData, data);
    }

    public getParams<T>(): IGameSessionParams {
        return {
            ...this.curSessionData,
        };
    }

    public setParams(keys: Map<string, unknown>): void {
        keys.forEach((value, key) => {
            if (this.curSessionData.hasOwnProperty(key)) {
                this.curSessionData[key] = value;
            }
        });
    }

    public getCurrentSessionData() {
        return this.curSessionData;
    }

    // will need to update these props from resize, some state actions, and sdk ad calls
    private createDefaultChangingParams(): IGameSessionChangingParams {
        return {
            screenHeight: 0,
            screenWidth: 0,
            levelsPassedThisSession: 0,
            levelsAttemptsThisSession: 0,
            boostersUsedThisSession: 0,
            adsWatchedThisSessionRewarded: 0,
            adsWatchedThisSessionInterstitial: 0,
            coinsEarnedThisSession: 0,
            coinsSpentThisSession: 0,
        };
    }

    private createGameStartParams(): IGameSessionStartParams {
        return {
            deviceType: this.getDeviceType(),
            gameID: 'moji',
            gameVersion: VERSION,
            operatingSystem: getOsName(),
            osVersion: parseInt(getOsVersion(), 10) || 0,
            platform: sgPlatform === 'fbinstant' ? GamePlatform.FBINSTANT : GamePlatform.LOCAL,
            platformUserID: 'not set yet', // this is only set once the fb initialize and initial loading is done...will have to set after
            sessionID: uuid(), // store and init with delta??
            tzOffset: new Date().getTimezoneOffset().toString(10),
            timezoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
            userID: 'not set yet',
            loadingTime: 0,
            locale: 'locale',
        };
    }

    private getDeviceType(): DeviceTypes {
        if (deviceIsPhone()) {
            return DeviceTypes.MOBILE_PHONE;
        }

        if (deviceIsTablet()) {
            return DeviceTypes.TABLET;
        }

        return DeviceTypes.PC;
    }
}
